import { GET, POST, DELETE } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchOfficeRequest = () =>
  GET("entitlement/ou").pipe(map((response: any) => response));

export const fetchBRByOfficeRequest = (id: string | number) =>
  GET(`entitlements/businessRole?ou=${id}`).pipe(
    map((response: any) => response)
  );

export const fetchEntitlementsByOuRequest = (ou: string | number) =>
  GET(`entitlements?ou=${ou}`).pipe(map((response: any) => response));

export const createBRRequest = (requestObj: FormData) =>
  POST(
    "businessRole",
    requestObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const modifyBRRequest = (requestObj: FormData) =>
  POST(
    "updateBusinessRole",
    requestObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const fetchDeleteBRRequest = (codeBR: any, attachments: FormData) =>
  DELETE(
    `businessRole/${codeBR}`,
    attachments,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const getBrEntitlements = (brId: string) =>
  GET(`entitlements/businessRoleEnt?brId=${brId}`).pipe(
    map((response: any) => response)
  );
